import { defineMessages } from 'react-intl';

export default defineMessages({
  stepTitle: {
    description: 'Title for the discounted rates step in the FTU wizard',
    defaultMessage: 'Set up order Rate Shopper',
    id: '1xZ0F6',
  },
  stepDescription: {
    description: 'Description for the discounted rates step in the FTU wizard',
    defaultMessage:
      'Save time and reduce errors by automating shipping tasks, like applying the lowest-rate service.(Note: you can always update label selection at time of print.)',
    id: 'OYlHc0',
  },
  stepDescriptionRateShopper: {
    description: 'Description for the discounted rates step in the FTU wizard',
    defaultMessage:
      'Save time and find the best rates by automating label selection for orders. (Note: you can always update label selection at time of print.) When you use Rate Shoppers, you are eligible for Shipping Credits.',
    id: 'XS8DkD',
  },
  shippingCreditsKBLink: {
    description: 'Shipping Credits help article link',
    defaultMessage: 'Learn more about shipping credits',
    id: 'hL1Uai',
  },
  carrierChoiceTitle: {
    description: 'Title for the carrier choice section',
    defaultMessage: 'Automate carrier choice',
    id: 'TmFCiB',
  },
  carrierChoiceDescription: {
    description: 'Description for the carrier choice section',
    defaultMessage: 'You can update your selection anytime, even at the time of shipping.',
    id: 'bwupw/',
  },
  recommendedOptionTitle: {
    description: 'Title for the recommended carrier option',
    defaultMessage: 'Recommended',
    id: 'VH0Hu6',
  },
  recommendedOptionDescription: {
    description: 'Description for the recommended carrier option',
    defaultMessage: 'Lowest cost option arriving on a specified date within 4 days.',
    id: '5H2K2X',
  },
  cheapestOptionTitle: {
    description: 'Title for the cheapest carrier option',
    defaultMessage: 'Cheapest',
    id: 'N2lKqa',
  },
  cheapestOptionDescription: {
    description: 'Description for the cheapest carrier option',
    defaultMessage: 'Compare carrier rates to automatically select the cheapest service.',
    id: '72wztq',
  },
  fastestOptionTitle: {
    description: 'Title for the fastest carrier option',
    defaultMessage: 'Fastest',
    id: 'FYEbtC',
  },
  fastestOptionDescription: {
    description: 'Description for the fastest carrier option',
    defaultMessage: 'The most cost effective way to deliver in 1 day.',
    id: 'UDYZWj',
  },
  bestValueOptionTitle: {
    description: 'Title for the best value carrier option',
    defaultMessage: 'Best Value',
    id: 'OmWCiU',
  },
  defaultBadge: {
    description: 'Text for the default badge on the recommended option',
    defaultMessage: 'Default',
    id: 'wx2G1t',
  },
  automationsTitle: {
    description: 'Title for the automations section',
    defaultMessage: 'Create more automations',
    id: 'D17Zg5',
  },
  automationsDescription: {
    description: 'Description for the automations section',
    defaultMessage: 'Add custom rules to select a service, apply order weight, apply tags, and much more.',
    id: '1rhJIg',
  },
  packageWeightTitle: {
    description: 'Title for the package weight automation',
    defaultMessage: 'Add Package Weight to Shipment',
    id: 'sKKy17',
  },
  packageWeightDescription: {
    description: 'Description for the package weight automation',
    defaultMessage: 'Avoid rate changes by factoring in packaging weight automatically.',
    id: 'rGnhSp',
  },
  internalNoteTitle: {
    description: 'Title for the internal note automation',
    defaultMessage: 'Add an Internal Note',
    id: 'qIEzfV',
  },
  internalNoteDescription: {
    description: 'Description for the internal note automation',
    defaultMessage: 'Add additional instructions to ensure the package is handled with care.',
    id: 'lDhT/0',
  },
  customerServiceTitle: {
    description: 'Title for the customer service automation',
    defaultMessage: "Assign customer's requested service",
    id: 'NXXnNK',
  },
  customerServiceDescription: {
    description: 'Description for the customer service automation',
    defaultMessage: "Apply a service and package based on your customer's selection at checkout.",
    id: 'y2eSyP',
  },
  activateButton: {
    description: 'Text for the activate button',
    defaultMessage: 'Activate',
    id: 'spxw8Z',
  },
  editButton: {
    description: 'Text for the edit button',
    defaultMessage: 'Edit',
    id: 'DsuGAs',
  },
  createRuleLink: {
    description: 'Text for the create rule link',
    defaultMessage: '+ Create Rule',
    id: 'LRdhke',
  },
  bestTooltip: {
    description: 'Text for the best tooltip automation',
    defaultMessage: 'Lowest cost option arriving within 4days that contains $100 of free carrier coverage.',
    id: 'YDcYi1',
  },
  cheapestTooltip: {
    description: 'Text for the most affordable tooltip automation',
    defaultMessage: 'Automatically selects the cheapest service.',
    id: 'yBBWsX',
  },
  fastestTooltip: {
    description: 'Text for the fastest tooltip automation',
    defaultMessage: 'The most cost-effective way to deliver in 1 day.',
    id: '0T1Pzv',
  },
  stepTitleWithInsurance: {
    description: 'Title for the discounted rates step with insurance in the FTU wizard',
    defaultMessage: 'Set up order Rate Shopper and Insurance',
    id: 'KlQ4UO',
  },
  stepDescriptionWithInsurance: {
    description: 'Description for the discounted rates step with insurance in the FTU wizard',
    defaultMessage:
      'Save time and reduce errors by automating shipping tasks, such as applying the lowest-rate service and setting up insurance. You can always update label selections at the time of printing and change insurance preferences in settings.',
    id: '7dg8PF',
  },
  insurancePreferencesTitle: {
    description: 'Title for the insurance preferences section',
    defaultMessage: 'Set up your Insurance preferences',
    id: 'JYCLPe',
  },
  insurancePopoverTitle: {
    description: 'Title for the insurance preferences popover',
    defaultMessage: 'Why do I need to insure my shipments?',
    id: 'KYKsbO',
  },
  insurancePopoverBody: {
    description: 'Body text for the insurance preferences popover',
    defaultMessage:
      'Save up to 67% compared to traditional carrier insurance with us. Enjoy peace of mind on every order with advanced coverage and a one-click claims process. Easily protect against lost, stolen, or damaged packages for both domestic and international shipments. ShipStation insurance is powered and provided by ParcelGuard.',
    id: 'aDfavl',
  },
  insurancePopoverLearnMore: {
    description: 'Learn more link text in the insurance preferences popover',
    defaultMessage: 'Learn more',
    id: 'T5YOcD',
  },
  insureAllTitle: {
    description: 'Title for the insure all shipments option',
    defaultMessage: 'Automatically insure all shipments',
    id: 'JLVHvo',
  },
  insureAllDescription: {
    description: 'Description for the insure all shipments option',
    defaultMessage: 'Automatically insure every shipment at full value.',
    id: 'Z0gbmK',
  },
  insureRulesTitle: {
    description: 'Title for the insure by rules option',
    defaultMessage: 'Automatically insure shipments based on specific rules',
    id: 'cpbOfu',
  },
  insureRulesDescription: {
    description: 'Description for the insure by rules option',
    defaultMessage: 'Create custom rules to apply insurance based on order value.',
    id: 't2O3uc',
  },
  insureSkipTitle: {
    description: 'Title for the skip insurance option',
    defaultMessage: 'Skip for now',
    id: 'XJjNYz',
  },
  insureSkipDescription: {
    description: 'Description for the skip insurance option',
    defaultMessage: 'You can enable coverage later in your account settings.',
    id: '/rcj4G',
  },
  insureSkipWarning: {
    description: 'Warning message shown when user selects skip insurance option',
    defaultMessage: 'Without our coverage, you may face costs for lost or damaged shipments.',
    id: 'kT4q9/',
  },
  recommendedBadge: {
    description: 'Text for the recommended badge on insurance option',
    defaultMessage: 'Recommended',
    id: '1iYS4a',
  },
  insuranceRuleSaveError: {
    description: 'Error notification when saving an insurance automation rule fails',
    defaultMessage: 'Failed to save insurance rule. Please try again.',
    id: 'YflVlh',
  },
  insurancePreferenceSaveError: {
    description: 'Error notification when auto-saving the default insurance preference fails',
    defaultMessage: 'Failed to save insurance preference. Please try again.',
    id: 'selubt',
  },
  activeParcelGuardRulesBannerTitle: {
    description: 'Info banner title shown on the FTU insurance step when an active ParcelGuard automation rule exists',
    defaultMessage: 'One or more automation rules are currently active',
    id: 'PVLmul',
  },
  activeParcelGuardRulesBannerBody: {
    description: 'Info banner body shown on the FTU insurance step when an active ParcelGuard automation rule exists',
    defaultMessage:
      'Your active rules will continue to apply insurance to matching shipments regardless of the setting you choose below. <a>Manage rules</a>',
    id: 'weoX9n',
  },
});
